(function () {
  function initCarousel(container) {
    if (container.dataset.storiesInit === 'true') return;
    container.dataset.storiesInit = 'true';

    var track = container.querySelector('.basiq-stories-carousel__track');
    if (!track) return;

    var speedSeconds = parseFloat(container.dataset.speed) || 40;
    var position = 0;
    var lastTime = null;
    var thirdWidth = 0;
    var isPaused = false;

    var isDragging = false;
    var dragStartX = 0;
    var dragStartPosition = 0;
    var dragMoved = false;

    function measure() {
      thirdWidth = track.scrollWidth / 3;
    }

    measure();
    window.addEventListener('resize', measure);

    function applyTransform() {
      var wrapped = position % thirdWidth;
      if (wrapped < 0) wrapped += thirdWidth;
      track.style.transform = 'translateX(' + (-wrapped) + 'px)';
    }

    function step(timestamp) {
      if (lastTime === null) lastTime = timestamp;
      var delta = timestamp - lastTime;
      lastTime = timestamp;

      if (!isPaused && !isDragging && thirdWidth > 0) {
        var pixelsPerMs = thirdWidth / (speedSeconds * 1000);
        position += pixelsPerMs * delta;
        applyTransform();
      }

      requestAnimationFrame(step);
    }

    requestAnimationFrame(step);

    container.addEventListener('mouseenter', function () {
      isPaused = true;
    });
    container.addEventListener('mouseleave', function () {
      isPaused = false;
      lastTime = null;
    });

    function pointerDown(clientX) {
      isDragging = true;
      dragMoved = false;
      dragStartX = clientX;
      dragStartPosition = position;
      container.classList.add('is-dragging');
    }

    function pointerMove(clientX) {
      if (!isDragging) return;
      var delta = clientX - dragStartX;
      if (Math.abs(delta) > 3) dragMoved = true;
      position = dragStartPosition - delta;
      applyTransform();
    }

    function pointerUp() {
      isDragging = false;
      lastTime = null;
      container.classList.remove('is-dragging');
    }

    container.addEventListener('mousedown', function (e) {
      pointerDown(e.clientX);
    });
    window.addEventListener('mousemove', function (e) {
      pointerMove(e.clientX);
    });
    window.addEventListener('mouseup', pointerUp);

    container.addEventListener('touchstart', function (e) {
      pointerDown(e.touches[0].clientX);
    }, { passive: true });
    container.addEventListener('touchmove', function (e) {
      pointerMove(e.touches[0].clientX);
    }, { passive: true });
    container.addEventListener('touchend', pointerUp);

    container.addEventListener('click', function (e) {
      if (dragMoved) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  }

  function initAll() {
    document.querySelectorAll('.basiq-stories-carousel').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();